// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Cousin imports
const collectionEditModalSelectors = require('../collection-edit-modal/selectors')
// Sibling imports
const actions = require('./actions')
const selectors = require('./selectors')

function mapStateToProps(state) {
  if (!selectors.isVisible(state)) {
    return { isVisible: false }
  }
  return {
    // Flags
    isPending: collectionEditModalSelectors.isCollectionUpdatePending(state),
    isNextPageAvailable: selectors.isNextPageAvailable(state),
    isNextPagePending: selectors.isNextPagePending(state),
    isVisible: true,
    // Values
    images: selectors.images(state),
    selectedImage: collectionEditModalSelectors.coverImage(state)
  }
}

const mapDispatchToProps = {
  onDelete: actions.deleteCoverImage,
  onDismiss: actions.hide,
  onImagesFetch: actions.fetchImages,
  onSelect: actions.toggleCoverImage
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
